module.exports = __webpack_public_path__ + "static/media/arrow-right.4b894be9.svg";